export default "__VITE_ASSET__Bk$6L3Su__"